import { render, staticRenderFns } from "./AttemptTargets.vue?vue&type=template&id=0a31927e&scoped=true&lang=pug&"
import script from "./AttemptTargets.vue?vue&type=script&lang=js&"
export * from "./AttemptTargets.vue?vue&type=script&lang=js&"
import style0 from "./AttemptTargets.vue?vue&type=style&index=0&id=0a31927e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a31927e",
  null
  
)

export default component.exports